<template>
  <div class="sort-item">
    <div class="cell br">
      <el-checkbox size="medium"
                   class="checkbox"
                   v-model="row.isShow"
                   :disabled="row.required == 1">
      </el-checkbox>
      <span class="label" style="">{{row.name}}</span>
    </div>
    <div class="cell br">
      <div class="text-muted" style="padding-right: 8px" v-if="row.required == 1">(必选)</div>
      <div class="text-muted">宽度：</div>
      <el-input style="width:160px;" placeholder="请输入宽度" v-model="row.width" @change="number">
        <template slot="append">px</template>
      </el-input>
    </div>
    <div class="cell">
      <div class="text-muted">对齐方式：</div>
      <el-select style="width:120px;" v-model="row.align">
        <el-option label="靠左" value="left"></el-option>
        <el-option label="居中" value="center"></el-option>
        <el-option label="靠右" value="right"></el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'SortItem',
    props: {
      row: {
        type: Object
      }
    },
    computed: {
      getResult() {
        return typeof this.row.required
      }
    },
    data() {
      return {
        isIndeterminate: true,
        // checked:false,
        isNumber:true
      }
    },

    methods: {

      number(){
        // alert("row.width:"+this.row.width);
        let reg = /[0-9]/;
        if (!reg.test(this.row.width) && this.row.width.toLowerCase()!=='auto') {
          this.isNumber=false;
          this.$message.error("宽度必须是数字或者auto");
        } else {

        }
      }
    },

  }
</script>
<style lang="scss" scoped>
  .sort-item {
    .el-checkbox{
      margin-right: 0;
    }
    display: flex;
    max-width: 100%;
    font-size: 13px;
    height: 30px;
    line-height: 29px;
    border: 1px solid #ddd;
    overflow: hidden;
    margin-top: -1px;
    .checkbox {
      padding-left: 6px;
      padding-right: 6px;
    }
    .label {
      cursor: move;
      background-color: #f5f5f5;
      line-height: 28px;
      display: inline-block;
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
      height: 100%;
      padding-left: 10px;
      padding-right: 20px;
      position: relative;
      top: -2px;
    }
  }
  .sort-item:first-of-type{
    margin-top: 6px;
  }
  .text-muted{
    white-space:nowrap;
  }
  .cell{
    display: flex;
    align-items: center;
    flex: 1;
    padding:0 10px;
  }
  .br{
    border-right: 1px solid #ddd
  }
</style>
